module.exports = __webpack_public_path__ + "img/l.246edd1d.jpg";